import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { ReplyJustificationActions } from "store/ducks/transports";

export function* replyJustificationRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/transports/reply-justification/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(ReplyJustificationActions.success(data));
    notify("success", "Justificativa respondida com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ReplyJustificationActions.failure(errorMessage));
  }
}
